import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { messages } from '../../constants/message';
import { userService } from '../../containers/user/services';
import { icons } from '../../constants/icons';
import useInterval from './Counter';
import { registerOTPResend } from '../../containers/user/actions/resendOtp';
import { countryAction } from '../../containers/Utils/actions/country';
import { Trans, useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile';
import Select, { createFilter } from 'react-select';
/**
 *
 * @param {signup authentication} author by Bilal Bhojani
 * @returns
 */

function Login({ closeSignup, openLogin }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const resend_otp = useSelector((state) => state.resendOtp);

    const [signUpInputs, setSignUpInputs] = useState({
        first_name: '',
        last_name: '',
        email: '',
        country_id: '112',
        password: '',
        cpassword: '',
        year: '',
    });

    const [fnameError, setFnameError] = useState('');
    const [lnameError, setLnameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [pwdError, setPwdError] = useState('');
    const [cpwdError, setCpwdError] = useState('');
    const [privacyError, setPrivacyError] = useState('');
    const [yearError, setYearError] = useState('');
    const [rawMobileNumber, setRawMobileNumber] = useState('');
    const [mobileError, setMobileError] = useState('');

    const { first_name, last_name, email, password, cpassword, year } = signUpInputs;
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [otpError, setOtpError] = useState(null);
    const [registerLoading, setRegisterLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [privacyToggle, setPrivacyToggle] = useState(false);
    const [passwordToggle, setPasswordToggle] = useState(false);
    const [confirmPasswordToggle, setConfirmPasswordToggle] = useState(false);
    const [emailOtp, setEmailOtp] = useState('');
    const [otpToggle, setOtpToggle] = useState(false);
    const [counter, setCounter] = useState(60);
    const countryVal = useSelector((state) => state.country);
    const yearOptions = ['firstYear', 'secondYear', 'thirdYear', 'fourthYear', 'fifthYear', 'sixthYear', 'seventhYear', 'graduateYear'];

    function handleLoginChange(e) {
        const { name, value } = e.target;
        setSignUpInputs((inputs) => ({ ...inputs, [name]: value }));
        if (name === 'first_name') {
            setFnameError('');
        }
        if (name === 'last_name') {
            setLnameError('');
        }
        if (name === 'email') {
            setEmailError('');
        }
        if (name === 'password') {
            setPwdError('');
        }
        if (name === 'cpassword') {
            setCpwdError('');
        }
        if (name === 'year') {
            setYearError('');
        }
    }

    function validateSignUpInputs() {
        let errors = {};
        const { first_name, last_name, email, password, cpassword, year } = signUpInputs;

        if (first_name === '') {
            errors.first_name = t('alertMessage.enterFirstName');
        } else if (first_name.trim().length <= 2) {
            errors.first_name = messages.FNAME_ERROR;
        }

        if (last_name === '') {
            errors.last_name = t('alertMessage.enterLastName');
        } else if (last_name.trim().length <= 2) {
            errors.last_name = messages.LNAME_ERROR;
        }

        if (!email) {
            errors.email = t('alertMessage.enterEmail');
        }

        if (password === '') {
            errors.password = t('alertMessage.enterPassword');
        } else if (password.trim().length <= 5) {
            errors.password = messages.PASSWORD_SHORT;
        }

        if (cpassword === '') {
            errors.cpassword = t('alertMessage.confirmPassword');
        } else if (cpassword.trim().length <= 5) {
            errors.cpassword = messages.PASSWORD_SHORT;
        } else if (password !== cpassword) {
            errors.cpassword = messages.PASSWORD_ERROR;
        }

        if (!privacyToggle) {
            errors.privacy = t('alertMessage.enterPP');
        }
        if (year === null) {
            errors.year = t('alertMessage.enterYear');
        }

        if (rawMobileNumber.trim().length <= 0) {
            errors.mobile_number = t('common.enterValidMobileNumber', 'Enter a valid mobile number');
        } else {
            const parsed = parsePhoneNumberFromString(`+${rawMobileNumber.replace(/^\+/, '')}`);
            if (!parsed || !parsed.isValid()) {
                errors.mobile_number = t(
                    'common.mobileCountryNotSupported',
                    'Enter a valid mobile number'
                );
            }
        }
        return errors;
    }

    async function registerStudent(event) {
        event.preventDefault();
        let errors = validateSignUpInputs();

        console.log('errors: ', errors);

        if (Object.keys(errors).length > 0) {
            if (errors['first_name'] !== '') {
                setFnameError(errors['first_name']);
            }
            if (errors['last_name'] !== '') {
                setLnameError(errors['last_name']);
            }
            if (errors['email'] !== '') {
                setEmailError(errors['email']);
            }
            if (errors['password'] !== '') {
                setPwdError(errors['password']);
            }
            if (errors['cpassword'] !== '') {
                setCpwdError(errors['cpassword']);
            }
            if (errors['privacy'] !== '') {
                setPrivacyError(errors['privacy']);
            }
            if (errors['year'] !== '') {
                setYearError(errors['year']);
            }
            if (errors['mobile_number'] !== '') {
                setMobileError(errors['mobile_number']);
            }
        } else {
            try {
                // Clear any previous errors
                setError(false);
                setErrorMsg(false);
                setRegisterLoading(true);

                await userService.register(
                    { ...signUpInputs, mobile_number: `00${rawMobileNumber.replace(/^\+/, '')}` },
                    'student'
                );
                setOtpToggle(true);

            } catch (error) {
                console.error('Register failed:', error.message);
                setError(true);
                setErrorMsg(error.message);
                setOtpToggle(false);
            } finally {
                setRegisterLoading(false);
            }
        }
    }

    useEffect(() => {
        if (privacyToggle) {
            setPrivacyError('');
        }
    }, [privacyToggle]);



    useInterval(() => {
        if (counter >= 1 && otpToggle) {
            setCounter(counter - 1);
        }
    }, 1000);

    useEffect(() => {
        if (resend_otp.status?.message === 'Otp Sended To Your Email !!') {
            setCounter(60);
        }
    }, [resend_otp.status]);

    useEffect(() => {
        dispatch(countryAction.getCountry());
    }, []);

    async function verifyEmailOTP() {
        try {
            setOtpError(null);
            setOtpLoading(true);
            await userService.registerVerificationOtp(email, emailOtp);
            window.location.reload();
        } catch (error) {
            console.error('OTP verification failed:', error.message);
            setOtpError(error.message);
        } finally {
            setOtpLoading(false);
        }
    }

    function resendOtp() {
        setOtpError(null);
        dispatch(registerOTPResend.sendOTPAgain(signUpInputs.email));
    }

    function goToLogin() {
        closeSignup();
        openLogin();
    }
    return (
        <div>
            <h2>{t('common.signUp')}</h2>
            <div className="lrf_subtext">
                {t('common.haveAccount')}
                <a
                    href="#"
                    onClick={goToLogin}
                    style={{
                        paddingLeft: '10px',
                        color: '#007bff',
                        textDecoration: 'underline',
                    }}
                >
                    {t('common.login')}
                </a>
            </div>
            <form onSubmit={registerStudent}>
                <div className="form_row">
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.firstName')}</label>
                            <div className="form_input">
                                <input
                                    type="text"
                                    value={first_name}
                                    className="form-control"
                                    name="first_name"
                                    onChange={handleLoginChange}
                                />
                                {fnameError && <p className="signup-error">{fnameError}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.lastName')}</label>
                            <div className="form_input">
                                <input
                                    type="text"
                                    value={last_name}
                                    className="form-control"
                                    name="last_name"
                                    onChange={handleLoginChange}
                                />
                                {lnameError && <p className="signup-error">{lnameError}</p>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.email')}</label>
                            <div className="form_input">
                                <input
                                    type="email"
                                    value={email}
                                    className="form-control"
                                    name="email"
                                    onChange={handleLoginChange}
                                />
                                {emailError && <p className="signup-error">{emailError}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.country')}</label>
                            <div className="form_input">
                                <Select
                                    name="country_id"
                                    className="react_select"
                                    isSearchable
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    onChange={(selected) => {
                                        setSignUpInputs((inputs) => ({
                                            ...inputs,
                                            country_id: selected ? String(selected.value) : '',
                                        }));
                                    }}
                                    value={
                                        countryVal &&
                                        (() => {
                                            const current = countryVal.country.find(
                                                (c) => String(c.value) === signUpInputs.country_id,
                                            );
                                            return current
                                                ? {
                                                      label: t('countries.' + current.label, current.label),
                                                      value: String(current.value),
                                                  }
                                                : null;
                                        })()
                                    }
                                    options={
                                        countryVal &&
                                        countryVal.country
                                            .filter((_) => _.label !== 'Israel')
                                            .map((_) => ({
                                                label: t('countries.' + _.label, _.label),
                                                value: String(_.value),
                                            }))
                                    }
                                    placeholder={t('common.selectYourCountry')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.mobileNumber')}</label>
                            <div className="form_input">
                                <PhoneInput
                                    country={'kw'}
                                    countryCodeEditable={false}
                                    value={rawMobileNumber}
                                    onChange={(phone) => {
                                        setRawMobileNumber(phone);
                                        setMobileError('');
                                    }}
                                    inputStyle={{ width: '100%' }}
                                />
                                {mobileError && <p className="signup-error">{mobileError}</p>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.year')}</label>
                            <div className="form_input">
                                <select
                                    name="year"
                                    className="form-control"
                                    onChange={handleLoginChange}
                                    value={signUpInputs.year}
                                >
                                    {yearOptions &&
                                        yearOptions.map((year) => {
                                            return <option>{t('year.' + year, year)}</option>;
                                        })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.password')}</label>
                            <div className="form_input">
                                <input
                                    type={passwordToggle ? 'text' : 'password'}
                                    value={password}
                                    className="form-control"
                                    name="password"
                                    onChange={handleLoginChange}
                                />
                                <span className="icon_eye">
                                    <img
                                        src={icons.icon_eye}
                                        alt=""
                                        onClick={() => {
                                            setPasswordToggle(!passwordToggle);
                                        }}
                                    />
                                </span>
                            </div>
                            {pwdError && <p className="signup-error">{pwdError}</p>}
                        </div>
                    </div>
                    <div className="form_col">
                        <div className="form-group">
                            <label for="">{t('common.rePassword')}</label>
                            <div className="form_input">
                                <input
                                    type={confirmPasswordToggle ? 'text' : 'password'}
                                    value={cpassword}
                                    className="form-control"
                                    name="cpassword"
                                    onChange={handleLoginChange}
                                />
                                <span className="icon_eye">
                                    <img
                                        src={icons.icon_eye}
                                        alt=""
                                        onClick={() => {
                                            setConfirmPasswordToggle(!confirmPasswordToggle);
                                        }}
                                    />
                                </span>
                            </div>
                            {cpwdError && <p className="signup-error">{cpwdError}</p>}
                        </div>
                    </div>
                </div>

                <div className="form_flx">
                    <div className="form_accept">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) => {
                                setPrivacyToggle(!privacyToggle);
                            }}
                            defaultChecked={privacyToggle}
                        />
                        <label className="form-check-label" for="gridCheck">
                            <Trans i18nKey="common.termsAndPrivacy">
                                I’ve read and agree to the
                                <a href="/privacy-policy" target="_blank">
                                    {' '}
                                    Terms of Use and Privacy Policy
                                </a>
                            </Trans>
                        </label>
                        {privacyError && <p className="signup-error">{privacyError}</p>}
                    </div>
                </div>
                {error && <p className="text-danger">{errorMsg}</p>}
                {!otpToggle && (
                    <button className="btn_primary full_btn big_btn" type="submit" disabled={registerLoading}>
                        {registerLoading && (
                            <span className="mr-2 spinner-border spinner-border-sm"></span>
                        )}
                        {t('common.register')}
                    </button>
                )}
            </form>
            {otpToggle && (
                <>
                    <div className="d-flex justify-content-center align-items-center">
                        <p className="text-center p-0">OTP sent to {email}</p>
                        <p
                            style={{
                                paddingLeft: '10px',
                                color: '#007bff',
                                textDecoration: 'underline',
                            }}
                            className="cursor_pointer"
                            onClick={() => {
                                setOtpToggle(false);
                                setEmailOtp('');
                            }}
                        >
                            Change Email Address
                        </p>
                    </div>
                    {otpError && <p className="text-center text-danger">{otpError}</p>}
                    <div className="row">
                        <div className="col-sm-5 col-md-5 col-lg-5">
                            <div className="form-group">
                                {/* <label for="">Enter OTP</label> */}
                                <div className="form_input">
                                    <input
                                        type="text"
                                        value={emailOtp}
                                        className="form-control"
                                        placeholder="Please enter OTP"
                                        name="emailOtp"
                                        onChange={(e) => setEmailOtp(e.target.value)}
                                        required
                                    />
                                </div>
                                <div>Resend OTP in {`${counter}`} secs.</div>
                            </div>
                        </div>
                        <div className="col-sm-7 col-md-7 col-lg-7">
                            <button className="btn_primary big_btn" onClick={verifyEmailOTP} disabled={otpLoading}>
                                {otpLoading && (
                                    <span className="mr-2 spinner-border spinner-border-sm"></span>
                                )}
                                Verify OTP
                            </button>
                            <button
                                className="btn_primary big_btn verify-btn"
                                disabled={counter > 0}
                                onClick={resendOtp}
                            >
                                Resend OTP
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Login;

